var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6582 4.12509L13.851 6.34999H19.6879L18.6582 4.12509ZM18.702 2.6723L10.7559 6.34999H1.99998C1.64099 6.34999 1.34998 6.64101 1.34998 6.99999V17C1.34998 17.359 1.64099 17.65 1.99998 17.65H2.89457L4.41482 21.0059C4.56295 21.3328 4.94812 21.4778 5.27512 21.3297L13.3769 17.6595L13.3726 17.65H22C22.359 17.65 22.65 17.359 22.65 17V6.99999C22.65 6.64101 22.359 6.34999 22 6.34999H21.1204L19.5649 2.98917C19.4141 2.66339 19.0278 2.52152 18.702 2.6723ZM10.2475 17.65H4.32174L5.33076 19.8773L10.2475 17.65ZM2.64998 9.25895V7.64999H4.25895C4.03627 8.42528 3.42527 9.03628 2.64998 9.25895ZM2.64998 10.5923V13.4077C4.14479 13.6764 5.32361 14.8552 5.59229 16.35H18.4077C18.6764 14.8552 19.8552 13.6764 21.35 13.4077V10.5923C19.8552 10.3236 18.6764 9.14478 18.4077 7.64999H5.59229C5.32361 9.1448 4.14479 10.3236 2.64998 10.5923ZM19.7411 7.64999C19.9637 8.42526 20.5747 9.03625 21.35 9.25893V7.64999H19.7411ZM21.35 14.741C20.5747 14.9637 19.9637 15.5747 19.7411 16.35H21.35V14.741ZM4.25895 16.35C4.03627 15.5747 3.42527 14.9637 2.64998 14.741V16.35H4.25895ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 9.99999 12 9.99999C10.8954 9.99999 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocation);
export default __webpack_public_path__ + "static/media/Allocation.5b0c1fef5c27a1062834fc7e69275f44.svg";
export { ForwardRef as ReactComponent };